import { render } from "./ZonesPage.vue?vue&type=template&id=ecf7145e&ts=true"
import script from "./ZonesPage.vue?vue&type=script&lang=ts"
export * from "./ZonesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__